<template>
  <div
    :class="['game_bot_box', {disabled}]"
    @click="emitSelectJoker"
  >
    <div class="noti_badge">{{ total }}</div>

    <p>{{ $_translations.value[`page_game_joker_name_${ type }`] }}</p>
  </div>
</template>

<script setup>
const emits = defineEmits(['select:joker']);

const props = defineProps({
  type: {
    type: String,
    define: '',
  },
  total: {
    type: Number,
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emitSelectJoker = () => {
  if (props.disabled) { return; }

  emits('select:joker', { type: props.type });
};
</script>
